import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { format } from "date-fns"
import dompurify from "dompurify"

import Dialog from "@/components/dialog/Dialog"
import BasicButton from "@/components/button/BasicButton"
import { useCreateNotificationReadHistoryMutation } from "@/hooks/api/useNoticeQuery"
import { DialogProps } from "@/types/components/dialog"
import { Notice } from "@/types/notice"

import "./latestNoticeDialog.scss"

export default function LatestNoticeDialog({
  title,
  content,
  dateCreated,
  idfNotice,
  isTeam,
  open,
  onClose,
}: Notice & Pick<DialogProps, "open" | "onClose">) {
  const { t } = useTranslation()
  const [date, setDate] = useState<Date | undefined>()

  const sanitize = dompurify.sanitize
  const mutation = useCreateNotificationReadHistoryMutation()

  useEffect(() => {
    if (dateCreated) {
      setDate(new Date(dateCreated))
    }
  }, [dateCreated])

  const handleClose = () => {
    mutation.mutate({ idfNotice, isTeam })
    onClose()
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      title={title}
      maxWidth="900px"
      footer={
        <BasicButton type="default-outlined" size="md" onClick={handleClose}>
          {t("button.close")}
        </BasicButton>
      }>
      <div className="LatestNoticeDialog-body">
        <div
          className="LatestNoticeDialog-content"
          dangerouslySetInnerHTML={{ __html: sanitize(content ?? "") }}
        />
        <p className="LatestNoticeDialog-date">{date && format(date, "yyyy-MM-dd")}</p>
      </div>
    </Dialog>
  )
}
